export enum CellScore {
    Bad = 0,
    BelowAvarage = 1,
    AboveAvarage = 2,
    Ambigious = 3,
    Unknown = 4,
}
